export default __webpack_public_path__ + "static/media/FAQ_5_1.fa955b22.png";